





















import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import DriverRequest from '@/model/request/DriverRequest'

@Component
export default class FilterDriver extends Mixins(MixinMember) {
  @Prop({required: true}) value!: DriverRequest
  @Prop({type: Array, default: () => []}) shown!: string[]
}
